<div class="login-container">
  <form [formGroup]="createPasswordForm">
    <img src="./assets/images/logo-bo-new-gen.png" alt="" height="32" width="109">
    <div class="box-center mt-2">
      <span class="title">ตั้งค่ารหัสผ่านใหม่</span>
      <span class="sub-title">กรุณากรอกรหัสผ่านใ้ห้ถูกต้อง</span>
    </div>
    <div class="not-match" *ngIf="checkValidate('passwordNotMatch')">
      <div>
        <span><img src="/assets/images/icon-valid.png" alt="" height="16" width="16"></span>
        รหัสผ่าน ไม่ตรงกัน! กรุณากรอก รหัสผ่าน ใหม่อีกครั้ง
      </div>
    </div>
    <div class="form-group mt-4">
    <label for="password">รหัสผ่าน</label>
    <div class="password-input-container mb-4">
      <input
        id="password"
        formControlName="password"
        [type]="isPasswordVisible ? 'text' : 'password'"
        placeholder="กรอกรหัสผ่าน"
      />
      <mat-icon
      class="password-toggle-icon"
      (click)="togglePasswordVisibility('password')">
      {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    </div>

    <label for="confirmPassword">ยืนยันรหัสผ่าน</label>
    <div class="password-input-container mb-2">
      <input
        id="confirmPassword"
        formControlName="confirmPassword"
        [type]="isConfirmPasswordVisible ? 'text' : 'password'"
        placeholder="กรอกรหัสผ่าน"
      />
      <mat-icon
      class="password-toggle-icon"
      (click)="togglePasswordVisibility('confirmPassword')">
      {{ isConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    </div>

    <div class="check-valid mb-4">
      <span class="fs-14">ข้อกำหนดรหัสผ่าน</span>
      <p><span>
        <img *ngIf="!checkValidate('length')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
        <img *ngIf="checkValidate('length')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
      </span>มีความยาว 8 ตัวอักษรขึ้นไป</p>
      <p><span>
        <img *ngIf="!checkValidate('az')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
        <img *ngIf="checkValidate('az')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
      </span>มีตัวอักษรพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัว</p>
      <p><span>
        <img *ngIf="!checkValidate('AZ')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
        <img *ngIf="checkValidate('AZ')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
      </span>มีตัวอักษรพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว</p>
      <p><span>
        <img *ngIf="!checkValidate('num')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
        <img *ngIf="checkValidate('num')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
      </span>มีตัวเลข (0-9) อย่างน้อย 1 ตัว</p>
      <p><span>
        <img *ngIf="!checkValidate('noSpecialChar')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
        <img *ngIf="checkValidate('noSpecialChar')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
      </span>ห้ามมีอักขระพิเศษ</p>
    </div>
    </div>
    <button type="submit" class="btn btn-primary login-button" (click)="onSubmit()" [disabled]="disabledButton()">ยืนยัน</button>
    <a class="btn c-primary" [routerLink]="'/auth/login'">
      <img src="./assets/images/arrow-left.png" alt="" height="16" width="16" style="margin-right: 4px;"> <span>กลับไปหน้าเข้าสู่ระบบ</span>
    </a>
  </form>
</div>